module.exports = __webpack_public_path__ + "img/neotag-product4.007b9c17.jpg";